import { apiClient } from './apiClient';
import { StaffMember, CreateStaffRequest, UpdateStaffRequest, AvailableModule } from '../types';

interface StaffApiResponse<T> {
    success: boolean;
    message?: string;
    data: T;
}

export const staffService = {
    /**
     * Get all staff members for the current shop
     */
    async getStaff(): Promise<StaffMember[]> {
        const response = await apiClient.get<StaffApiResponse<StaffMember[]>>('/staff');
        return response.data || [];
    },

    /**
     * Get a specific staff member
     */
    async getStaffMember(id: number): Promise<StaffMember> {
        const response = await apiClient.get<StaffApiResponse<StaffMember>>(`/staff/${id}`);
        return response.data;
    },

    /**
     * Create a new staff member
     */
    async createStaff(data: CreateStaffRequest): Promise<StaffMember> {
        const response = await apiClient.post<StaffApiResponse<StaffMember>>('/staff', data);
        return response.data;
    },

    /**
     * Update a staff member
     */
    async updateStaff(id: number, data: UpdateStaffRequest): Promise<StaffMember> {
        const response = await apiClient.put<StaffApiResponse<StaffMember>>(`/staff/${id}`, data);
        return response.data;
    },

    /**
     * Update staff member permissions
     */
    async updatePermissions(id: number, permissions: Array<{
        module: string;
        can_view: boolean;
        can_create: boolean;
        can_edit: boolean;
        can_delete: boolean;
    }>): Promise<StaffMember> {
        const response = await apiClient.put<StaffApiResponse<StaffMember>>(`/staff/${id}/permissions`, { permissions });
        return response.data;
    },

    /**
     * Delete a staff member
     */
    async deleteStaff(id: number): Promise<void> {
        await apiClient.delete(`/staff/${id}`);
    },

    /**
     * Get available modules for permission configuration
     */
    async getAvailableModules(): Promise<AvailableModule[]> {
        const response = await apiClient.get<StaffApiResponse<AvailableModule[]>>('/staff/modules');
        return response.data || [];
    },
};

export default staffService;
